/** The editor's screen state in the URL: the open step, the view, and the side panel. */
export interface IEditorSearch {
  node?: string;
  /** An agent step's open tool, by its key (`t_2`); only read with `node`. */
  tool?: string;
  /** An agent test of `node` (Д31), by its test session id. */
  agentTest?: string;
  view?: 'live' | 'compare';
  /** Compare against this version number; absent is the live one. */
  against?: number;
  panel?: 'issues' | 'history';
  /** Live's window; absent is the last 24 hours. */
  period?: '1h' | '7d';
  /** `?test=1` (⌘K "Test draft of …"): opens on a test of the draft, default sample, nothing sent. */
  test?: true;
}

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value !== '' ? value : undefined;

export const parseEditorSearch = (search: Record<string, unknown>): IEditorSearch => {
  const view = text(search.view);
  const panel = text(search.panel);
  const period = text(search.period);
  const against = Number(search.against);
  return {
    node: text(search.node),
    tool: search.node ? text(search.tool) : undefined,
    agentTest: search.node ? text(search.agentTest) : undefined,
    view: view === 'live' || view === 'compare' ? view : undefined,
    against: Number.isInteger(against) && against > 0 ? against : undefined,
    panel: panel === 'issues' || panel === 'history' ? panel : undefined,
    period: period === '1h' || period === '7d' ? period : undefined,
    test: search.test === 1 || search.test === '1' || search.test === true ? true : undefined,
  };
};
